import styled from 'styled-components';
import { StockSliceStyled } from '../StockSliceStyled';

export const StockSliceStyledOV = styled(StockSliceStyled)``;
